module.exports = __webpack_public_path__ + "img/getCoupons_bg_yhh.e58ea205.jpeg";